<template>
  <div class="register-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $t('global.register') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="registryShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'RegisterHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            registryShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.registryGridTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.patientsManagement'),
                            shortcuts: [
                                { key: 'F10' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.patientsManagement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.newCase'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'N' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.newCase')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.editCase'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'E' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.editCase')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.reports'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'R' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.reports')
                        }
                    ]
                },
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.registryFormTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.patientsManagement'),
                            shortcuts: [
                                { key: 'F10' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.patientsManagement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.newCase'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'N' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.newCase')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.deleteRegistry'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: this.$t('component.shortcutsModal.delKey') }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.deleteRegistry')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.finalizeRegistry'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'F' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.finalizeRegistry')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.saveRegistry'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'S' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.saveRegistry')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.finalizeAndPrintRegistry'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.finalizeAndPrintRegistry')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.caseSection'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '1' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.caseSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.samplesSection'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '2' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.samplesSection')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.addSamples'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: '+' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.addSamples')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.assaysRegistry'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'A' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.assays')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
